
import Vue from "vue";
import Card from "../components/Card.vue";
import LargeCard from "../components/LargeCard.vue";
import SelectTag from "../components/SelectTag.vue";
import CardData from "../models/CardData";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import { ICardData } from "../@types/interface.d";

interface IData {
  cards: CardData[];
  maximizeCard?: CardData;
  selectedTags: boolean[];
  exact: boolean,
  from?: Date;
  to?: Date;
  limit: number;
  sort: string;
  offset: number;
  searchCount: number;
  showSort: boolean;
}

export default Vue.extend({
  name: "cards",
  components: {
    Card,
    LargeCard,
    SelectTag,
    Headline,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): IData {
    return {
      cards: [],
      maximizeCard: undefined,
      selectedTags: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      exact: false,
      limit: 12,
      from: undefined,
      to: undefined,
      sort: "random",
      offset: 0,
      searchCount: 0,
      showSort: location.search.indexOf("advanced") !== -1,
    };
  },
  created() {
    // this.init();
  },
  computed: {
    padCount(): number {
      const mod = this.cards.length % 4;
      return mod === 0 ? 0 : 4 - mod;
    },
    pageCount(): number {
      const ret = Math.floor(this.searchCount / this.limit);
      return this.searchCount % this.limit === 0 ? ret : ret + 1;
    },
    page(): number {
      return (this.offset / this.limit) + 1;
    },
  },
  methods: {
    selectTag(tagId: number) {
      this.selectedTags = this.selectedTags.map((v, i) => {
        if (i + 2 === tagId) {
          v = !v;
        }
        return v;
      });
    },
    onSelect(id: number) {
      if (this.maximizeCard) {
        this.maximizeCard = undefined;
        return;
      }
      const card = this.cards.find(v => v.id === id);
      if (!card) {
        return;
      }
      this.maximizeCard = card;
    },
    clearMaximize() {
      this.maximizeCard = undefined;
    },
    search() {
      const tags = this.selectedTags.map((v, i) => v ? i + 2 : 0).filter(v => v !== 0).join(",");
      fetch(`/api/search?tags=${tags}&exact=${this.exact}&offset=${this.offset}&limit=${this.limit}&sort=${this.sort}`)
        .then(res => res.json())
        .then((data) => {
          this.cards = data.list.map((v: ICardData) => new CardData(v, true));
          this.searchCount = data.count;
        });
    },
    changeLimit(e: { target: HTMLSelectElement }) {
      this.limit = parseInt(e.target.value, 10);
    },
    changeSort(e: { target: HTMLSelectElement }) {
      this.sort = e.target.value;
    },
    changeExact(e: { target: HTMLInputElement }) {
      this.exact = e.target.checked;
    },
    onPaginate(page: number) {
      this.offset = (page - 1) * this.limit;
      this.search();
    },
  },
});
